module.exports = __webpack_public_path__ + "img/reverse-left.bc2a28cb.svg";